import { customersV2Ops } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import {
  SLOC_CUSTOMER_HAS_KEY_QUERY,
  SLOC_CUSTOMER_NAME_QUERY,
  SLOC_HAS_VALID_KEY_QUERY,
} from "./slocQueryKeys";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("customer"),
  endpoint: "customers",
  operations: customersV2Ops,
  roleView: [ROLE.CUSTOMER_VIEW, ROLE.CUSTOMER_ADMIN],
  roleAdmin: [ROLE.CUSTOMER_ADMIN],
  singularName: (t) => t("Customer"),
  name: (t) => t("Customers"),
  apiVersion: "v2",
  // Editing a customer may change its SLOC API key, so refresh the SLOC validation/name lookups
  // shown on the customer and container detail pages.
  dependencies: [SLOC_HAS_VALID_KEY_QUERY, SLOC_CUSTOMER_HAS_KEY_QUERY, SLOC_CUSTOMER_NAME_QUERY],
});

export default conf;
